import React, { useState, useEffect, Fragment, useRef } from 'react';
import services from '../../services';
import { validateProperty, validate } from "../../../Common"
import { PurchaseAdviceAddEditObject, OrderItemAddEditObject, OrderItemAddEditObjectForUnit, UnitPriceUpdateObject } from '../../purchaseAdvice'
import MessageModal from '../../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import groupService from '../../../Group/services';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import { TableContentPurchaseView } from '../../../Common/Table/tableContent';
import MenuItem from '@material-ui/core/MenuItem';
import { CommonDecryptParam } from '../../../../../utils/CommonParams';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router';
import { CommonEncryptParam } from '../../../../../utils/CommonParams';
import Autocomplete from '@material-ui/lab/Autocomplete';
import exportSupplierService from '../../../ExportSupplier/service';
import { generateStatus } from '../../satusGenerator';
import { SignalCellularNullOutlined } from '@material-ui/icons';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Divider } from '@material-ui/core';

const screenCode = 'PURCHASEORDER';

export function ViewOrdersAddEdit(props) {

    const componentRef = useRef();
    let history = useHistory();
    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
    });
    const tableHeaderStyle = {
        color: "#263238",
        textTransform: "uppercase",
        fontSize: "12px",
        fontWeight: "bold"
    }
    const subTableHeaders = {
        textTransform: "uppercase",
        fontSize: "12px"
    }

    const [title, setTitle] = useState("Add Order")
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionTypes, setCollectionTypes] = useState([]);
    const [buyers, setBuyers] = useState([]);
    const [orderItemArray, setOrderItemArray] = useState([]);
    const [purchaseAdvice, setPurchaseAdvice] = useState({
        groupID: '0',
        operationEntityID: '0',
        buyerID: '0',
        invoiceDate: new Date().toISOString().split('T')[0],
        dueDate: new Date().toISOString().split('T')[0],
        statusTypeID: 0
    });

    const [purchaseForPDF, setPurchaseForPDF] = useState({
        group: "",
        operationEntity: "",
        buyer: "",
        invoiceDate: "",
        dueDate: "",
    });

    const [purchaseOrderItem, setPurchaseOrderItem] = useState({
        collectionTypeID: '0',
        measuringUnit: '0',
        price: '',
        packageWeight: '',
        totalPackagesStore: '',
        totalPackagesExport: '',
        itemQuantity: '',
        maxAmount: '',
        aspNetUserId: '0',
        newunitprice: ''
    });
    const [errors, setErrors] = useState({});
    const [orderItemErrors, setOrderItemErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [itemDetails, setItemDetails] = useState([]);
    const [supplierID, setSupplierID] = useState([]);
    const [orderItemName, setOrderItemName] = useState({});
    const [orderDetails, setOrderDetails] = useState({});
    const [supplierName, setSupplierName] = useState({});
    const [unitPrice, setUnitPrice] = useState({});
    const [users, setUsers] = useState([]);
    const [items, setItems] = useState(0);
    const [newunitprice, setNewUnitPrice] = useState({
        unitprice: ''
    });
    const schema = Joi.object(PurchaseAdviceAddEditObject).options({ allowUnknown: true });
    const orderItemsschema = Joi.object(OrderItemAddEditObject).options({ allowUnknown: true });
    const orderItemsschemaForUnit = Joi.object(OrderItemAddEditObjectForUnit).options({ allowUnknown: true });
    const UnitPriceUpdateSchema = Joi.object(UnitPriceUpdateObject).options({ allowUnknown: true });
    

    const contentRowNames = ["collectionTypeName", "userName", "price", "packageWeight",
        "measuringUnit", "totalPackagesStore", "totalPackagesExport", "itemQuantity", "maxAmount"];
    const [isEditScreen, setIsEditScreen] = useState(false);

    const encriptedTest = props.match.params["id"];
    const id = (encriptedTest !== undefined) ? CommonDecryptParam(props.match.params["id"]) : 0;
    const data = id > 0 ? true : false;
    const edit = id > 0 ? true : false;
    const [openDialog, setOpenDialog] = React.useState(false);

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getCompanies()
        );
    }, [purchaseAdvice.groupID]);

    useEffect(() => {
        trackPromise(
            getItems(),
            getBuyers(),
            getUsers()
        );
    }, [purchaseAdvice.operationEntityID]);

    useEffect(() => {
        if (messageModel.hidden === false) {
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 2000);
        }
    }, [messageModel])

    useEffect(() => {
        trackPromise(
            setSelectedSearchData()
        );
    }, [buyers]);

    useEffect(() => {
        if (parseFloat(purchaseOrderItem.totalPackagesStore) >= parseFloat(purchaseOrderItem.totalPackagesExport)) {
            setOrderItemErrors({
                ...orderItemErrors,
                orderItem: "Max Total Packages value is less than total package"
            });
        } else if (purchaseOrderItem.measuringUnit === "2" &&
            parseFloat(purchaseOrderItem.itemQuantity) >= parseFloat(purchaseOrderItem.maxAmount)) {
            setOrderItemErrors({
                ...orderItemErrors,
                orderItem: "Max amount is less than exact amount."
            });
        } else {
            const error = { ...orderItemErrors }
            delete error["orderItem"]
            setOrderItemErrors(error);
        }
    }, [purchaseOrderItem])

    useEffect(() => {
        setItems(orderItemArray.filter(x => x.state !== 2).length)
    }, [orderItemArray])

    useEffect(() => {
        if (purchaseOrderItem.measuringUnit === "1") {
            setPurchaseOrderItem({
                ...purchaseOrderItem,
                itemQuantity: '',
                maxAmount: ''
            })
        } else if (purchaseOrderItem.measuringUnit === "2") {
            setPurchaseOrderItem({
                ...purchaseOrderItem,
                packageWeight: '',
                totalPackagesStore: '',
                totalPackagesExport: ''
            })
        } else {
            setPurchaseOrderItem({
                ...purchaseOrderItem,
                itemQuantity: '',
                maxAmount: '',
                packageWeight: '',
                totalPackagesStore: '',
                totalPackagesExport: ''
            })
        }
    }, [purchaseOrderItem.measuringUnit]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITPURCHASEORDERS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });
        setEditScreenData();
        setIsEditScreen(true);

        trackPromise(
            getAllGroups()
        )
    }

    async function getAllGroups() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups)
    }

    async function getCompanies() {
        const companies = await services.getMultiCropsByGroupID(purchaseAdvice.groupID);
        setOperationEntity(companies);
    }

    async function getItems() {
        const items = await services.GetCollectionTypeByOperationEntityForSearchDropDown(purchaseAdvice.operationEntityID);
        setCollectionTypes(items);
    }

    async function getBuyers() {
        const buyerRes = await services.GetBuyerByOperationEntity(purchaseAdvice.operationEntityID);
        setBuyers(buyerRes);
    }

    async function getUsers() {
        const userRes = await services.getUsers(purchaseAdvice);
        setUsers(userRes);
    }

    async function setEditScreenData() {

        var result = await services.getSelectedOrderDetails(id);
        var supplierOrderItemsArray = result.supplierOrderItems;

        if (result.order.statusTypeID === 1 || result.order.statusTypeID === 0) {
            setTitle("Edit Order");
        } else {
            setTitle("View Order");
        }
        setExpandTableData();

        setPurchaseAdvice({
            ...purchaseAdvice,
            groupID: result.order.groupID,
            operationEntityID: result.order.operationEntityID,
            buyerID: result.order.buyerID,
            invoiceDate: result.order.invoiceDate.split('T')[0],
            dueDate: result.order.dueDate.split('T')[0],
            orderID: result.order.orderID,
            statusTypeID: result.order.statusTypeID
        });



        const userRes = await services.getUsers({ groupID: result.order.groupID, operationEntityID: result.order.operationEntityID });

        result.orderItems.forEach((x, i) => {

            var hasSupplieritems = supplierOrderItemsArray.filter(y => y.orderItemID === x.orderItemID);

            if (hasSupplieritems.length > 0) {
                x.isButtonEnabled = 0;
            } else {
                x.isButtonEnabled = 1;
            }

            x.userName = userRes[x.aspNetUserId];
            x.state = 0;
            x.indexNo = i
        })

        setOrderItemArray(result.orderItems);
    }

    function handleChange(e) {
        const target = e.target
        const value = target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, PurchaseAdviceAddEditObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setPurchaseAdvice({
            ...purchaseAdvice,
            [e.target.name]: value
        })
        setErrors(error)
    }

    function handleDateChange(e) {

        if (e.target.value < new Date().toISOString().split('T')[0]) {
            setErrors({
                ...errors,
                dueDate: "Due can not be Early Date than Invoice Date"
            });
            return;

        } else {
            const error = { ...errors }
            delete error["dueDate"]
            setErrors(error);
            handleChange(e);
        }
    }

    function handleSearchDropdownChange(data) {

        if (data === undefined || data === null)
            return;

        var nameV = "collectionTypeID";
        var valueV = data["collectionTypeID"];

        const error = { ...orderItemErrors }
        var errorMessage = "";
        if (purchaseOrderItem.measuringUnit === "1") {
            errorMessage = validateProperty({ name: nameV, value: valueV }, OrderItemAddEditObject)
        } else {
            errorMessage = validateProperty({ name: nameV, value: valueV }, OrderItemAddEditObjectForUnit)
        }
        errorMessage ? error[nameV] = errorMessage : delete error[nameV];

        setPurchaseOrderItem({
            ...purchaseOrderItem,
            collectionTypeID: valueV.toString()
        });

        setOrderItemErrors(error);
    }


    function handlePurchaseItemChange(e) {
        const target = e.target;
        const value = target.value;
        const error = { ...orderItemErrors }
        var errorMessage = "";
        if (purchaseOrderItem.measuringUnit === "1") {
            errorMessage = validateProperty(target, OrderItemAddEditObject)
        } else {
            errorMessage = validateProperty(target, OrderItemAddEditObjectForUnit)
        }
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setPurchaseOrderItem({
            ...purchaseOrderItem,
            [e.target.name]: value
        })
        setOrderItemErrors(error);
    }

    function handlUnitPriceChange(e) {
        const value = e.target.value;

        setNewUnitPrice({
            ...newunitprice,
            unitprice: value
        });
    }

    async function handleSave(e) {
        e.preventDefault()

        const errorMessages = validate(schema, purchaseAdvice);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        var orderItem = orderItemArray.filter(x => x.state === 2);

        if (orderItem.length >= orderItemArray.length) {
            setOrderItemErrors({
                ...errors,
                orderItem: "Please add at least one Item."
            });
            return;
        }

        const response = await services.editOrder(purchaseAdvice, orderItemArray);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
        afterSuccessfulyChanged(response.statusCode);
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/PurchaseAdvice' })
            }, 1500);
        } else {
            setEditScreenData();
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setPurchaseAdvice({
            ...purchaseAdvice,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntity,
            buyerID: permissionList.isGroupFilterEnabled ? '0' : token.buyerID,
            invoiceDate: new Date().toISOString().split('T')[0],
            dueDate: new Date().toISOString().split('T')[0],
            collectionTypeID: '0',
            itemQuantity: '',
            measuringUnit: ''
        })

    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    async function UpdateUnitPrice() {
        const response = await services.UpdateNewUnitPrice(newunitprice, supplierID,unitPrice);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
        afterSuccessfulyChanged(response.statusCode);
    }

    function handleAddItem() {
        var selectedItem = collectionTypes.find((x, index) => x.collectionTypeID === parseInt(purchaseOrderItem.collectionTypeID));

        if (orderItemErrors.orderItem) {
            return;
        }

        const newOrderItem = {
            orderItemID: 0,
            collectionTypeName: selectedItem.collectionTypeName,
            price: parseFloat(purchaseOrderItem.price),
            measuringUnit: parseInt(purchaseOrderItem.measuringUnit),
            collectionTypeID: parseInt(purchaseOrderItem.collectionTypeID),
            itemQuantity:
                parseFloat(purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesStore),
            state: 1,
            packageWeight: parseFloat(purchaseOrderItem.packageWeight),
            totalPackagesStore: parseInt(purchaseOrderItem.totalPackagesStore),
            totalPackagesExport: parseInt(purchaseOrderItem.totalPackagesExport),
            maxAmount:
                parseFloat(purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesExport),
            aspNetUserId: parseInt(purchaseOrderItem.aspNetUserId),
            isButtonEnabled: 1,
            userName: users[purchaseOrderItem.aspNetUserId],
            indexNo: (orderItemArray.length) - 1
        }

        setOrderItemArray([...orderItemArray, newOrderItem]);
        setPurchaseOrderItem({
            ...purchaseOrderItem,
            collectionTypeID: '0',
            measuringUnit: '0',
            price: '',
            packageWeight: '',
            totalPackagesStore: '',
            totalPackagesExport: '',
            itemQuantity: '',
            maxAmount: '',
            aspNetUserId: '0'
        })
    }

    function handleItemRemoveClick(data) {
        var allorderItems = [...orderItemArray];

        var selectedItems = allorderItems.filter(x => (parseInt(x.collectionTypeID) === parseInt(data.collectionTypeID)) &&
            x.indexNo === data.indexNo);
        var indexOfSelectedItems = 0;

        allorderItems.forEach((x, i) => {
            if ((parseInt(x.collectionTypeID) === parseInt(data.collectionTypeID))) {
                indexOfSelectedItems = i;
            }
        });

        var updatedArray = allorderItems.filter(x => (parseInt(x.collectionTypeID) !== parseInt(data.collectionTypeID) &&
            x.indexNo !== data.indexNo));

        var resItemDetails = itemDetails.filter(x => x.orderItemID !== data.orderItemID);
        setItemDetails(resItemDetails);

        if (selectedItems[0].state === 0) {
            allorderItems[indexOfSelectedItems].state = 2;
            setOrderItemArray(allorderItems);
        } else {
            setOrderItemArray(updatedArray);
        }
    }

    async function onRemoveClick() {
        const response = await services.removeOrder(id);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
        afterSuccessfulyChanged(response.statusCode);
    }

    function roundNumber(num) {
        return (Math.round(num * 100) / 100).toFixed(2);
    }

    function createData(orderItemID, collectionTypeName, collectionTypeID, itemQuantity,
        measuringUnit, state, supplierItems) {
        return {
            orderItemID,
            collectionTypeName,
            collectionTypeID,
            itemQuantity,
            measuringUnit,
            state,
            supplierItems
        };
    }

    async function setExpandTableData() {
        var result = await services.getSelectedOrderDetails(id);
        if (result.supplierOrderItems.length > 0 && result.orderItems.length > 0) {

        setSupplierID(result.supplierOrderItems[0].supplierOrderItemsID) 
        setOrderItemName(result.orderItems[0].collectionTypeName);
        setOrderDetails(result.order);
        setSupplierName(result.supplierOrderItems[0].firstName);
        setUnitPrice(result.supplierOrderItems[0].unitPrice)
        }
        
        var items = [];

        result.orderItems.forEach(x => {
            var supplierItems = [];

            result.supplierOrderItems.forEach(r => {
                if (r.orderItemID === x.orderItemID) {
                    supplierItems.push({
                        supplierOrderItemsID: r.supplierOrderItemsID,
                        orderItemID: r.orderItemID,
                        customerID: r.customerID,
                        supplierName: r.firstName,
                        unitPrice: r.unitPrice,
                        totalPrice: r.suppliedQauntity * parseFloat(r.unitPrice),
                        supplingQauntity: r.supplingQauntity,
                        lastUnitPrice: r.lastUnitPrice,
                        statusType: r.statusTypeID,
                        version: r.version,
                        remark: r.remark,
                        suppliedQauntity: r.suppliedQauntity
                    })
                }
            })

            items.push(
                createData(
                    x.orderItemID,
                    x.collectionTypeName,
                    x.collectionTypeID,
                    x.itemQuantity,
                    x.measuringUnit,
                    x.state,
                    supplierItems
                )
            );

        });

        setItemDetails(items);
    }

    async function setSelectedSearchData() {

        var buyerName = "";
        buyers.forEach(x => {
            if (purchaseAdvice.buyerID == x.buyerID) {
                buyerName = x.buyerName + " - " + x.buyerCode;
            }
        });

        setPurchaseForPDF({
            ...purchaseForPDF,
            group: groups[purchaseAdvice.groupID],
            operationEntity: operationEntity[purchaseAdvice.operationEntityID],
            buyer: buyerName,
            invoiceDate: purchaseAdvice.invoiceDate,
            dueDate: purchaseAdvice.dueDate
        })
    }

    async function viewSupplierItemDetails(rowData, itemData) {
        history.push({
            pathname: 'viewWieghment/' + CommonEncryptParam(itemData.supplierOrderItemsID.toString()),
            data: id
        })
    }

    function handleClickOpen() {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setDailogBoxEmpty();
        setOpenDialog(false);
    };

    function setDailogBoxEmpty() {
        const error = { ...errors }
        delete error["supplierItemErrMsg"]
        setErrors(error);
    }

    async function bindBuyer(value) {
        setPurchaseAdvice(
            {
                ...purchaseAdvice,
                buyerID: value.buyerID
            }
        );
    }
    function test(option, value) {
    }



    function Row(props) {
        const { row } = props;
        const [open, setOpen] = React.useState(true);
        const classes = useRowStyles();


        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row.collectionTypeName}
                    </TableCell>
                    <TableCell align="right">{row.itemQuantity}</TableCell>
                    <TableCell align="right" component="th" scope="row">
                        {row.measuringUnit === 1 ? "Kg" : "Unit"}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, backgroundColor: "#FAFAFA" }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {row.supplierItems.length !== 0 ? <Box marginLeft={20}>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={subTableHeaders}><b>Supplier</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Quantity</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Unit Price</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Last Unit Price</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Weighment Quantity</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Total price (LKR.)</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Remark</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Status</b></TableCell>
                                            <TableCell align="center" style={subTableHeaders}><b>Action</b></TableCell>
                                            <TableCell align="center" style={subTableHeaders}><b>Change Unit Price</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.supplierItems.map((itemData, i) => {
                                            if (itemData.orderItemID === row.orderItemID) {
                                                return (
                                                    <TableRow key={i} style={(itemData.statusType === 7 || itemData.statusType === 9) ? { backgroundColor: "#FFEBEE" } : null}>
                                                        <TableCell component="th" scope="row"> {itemData.supplierName} </TableCell>
                                                        <TableCell align="right">{itemData.supplingQauntity}</TableCell>
                                                        <TableCell align="right">{roundNumber(itemData.unitPrice)}</TableCell>

                                                        <TableCell align="right">{roundNumber(itemData.lastUnitPrice)}</TableCell>
                                                        <TableCell align="right">{roundNumber(itemData.suppliedQauntity)}</TableCell>
                                                        <TableCell align="right">{roundNumber(itemData.totalPrice)}</TableCell>
                                                        <TableCell align="right">{itemData.remark ? itemData.remark : "-"}</TableCell>
                                                        <TableCell align="right">
                                                            {
                                                                generateStatus(itemData.statusType)
                                                            }
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <i
                                                                style={{ cursor: "pointer" }}
                                                                className="fas fa-eye"
                                                                onClick={() => viewSupplierItemDetails(row, itemData)}
                                                            >
                                                            </i>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <i
                                                                style={{ cursor: "pointer" }}
                                                                className="far fa-edit"
                                                                onClick={handleClickOpen}
                                                            >
                                                            </i>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        })}
                                    </TableBody>
                                </Table>
                            </Box> : <p style={{ fontSize: "14px" }}>No Suppliers.</p>}
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/PurchaseAdvice"
                        />
                        <hr />
                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="operationEntityID">Group *</InputLabel>
                                        <Select fullWidth
                                            id="groupID"
                                            name="groupID"
                                            value={purchaseAdvice.groupID}
                                            disabled={orderDetails.statusTypeID === 5 || !permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="operationEntityID">Company *</InputLabel>
                                        <Select fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={purchaseAdvice.operationEntityID}
                                            disabled={orderDetails.statusTypeID === 5 || !permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Company--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        {orderDetails.statusTypeID === 5 ?
                                            <>
                                                <InputLabel shrink id="operationEntityID">Company *</InputLabel>
                                                <Select fullWidth
                                                    id="buyerID"
                                                    name="buyerID"
                                                    value={purchaseAdvice.buyerID}
                                                    disabled={orderDetails.statusTypeID === 5 || !permissionList.isOperationEntityFilterEnabled}
                                                    onChange={(e) => handleChange(e)}>
                                                    <MenuItem value="0">--Select Company--</MenuItem>
                                                    {buyers.map((item) => (<MenuItem value={item.buyerID}>{item.buyerName + " - " + item.buyerCode}</MenuItem>))}
                                                </Select>
                                            </>
                                            :
                                            <Autocomplete
                                                id="buyerID"
                                                options={buyers}
                                                getOptionLabel={(option) => option.buyerName + " - " + option.buyerCode}
                                                getOptionSelected={(option, value) => option.buyerID == value}

                                                value={purchaseAdvice.buyerID}
                                                renderInput={(params) => <TextField {...params} label="Buyer *" variant="outlined" size="small" />}
                                            />

                                        }
                                        {errors["buyerID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["buyerID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Invoice Date *"
                                            name="invoiceDate"
                                            id="invoiceDate"
                                            disabled={true}
                                            value={purchaseAdvice.invoiceDate}
                                            type="date"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["invoiceDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["invoiceDate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Due Date *"
                                            name="dueDate"
                                            id="dueDate"
                                            value={purchaseAdvice.dueDate}
                                            disabled={orderDetails.statusTypeID === 5}
                                            type="date"
                                            maxLength="50"
                                            onChange={(e) => handleDateChange(e)} />
                                        {errors["dueDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["dueDate"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div>
                                    {orderDetails.statusTypeID !== 5 ?
                                        <div>
                                            <div className="card-title pt-3"><p style={{ fontSize: "16px" }}>Item Details</p></div>
                                            <div className="form-group row">
                                                <div className="col-md pt-3">
                                                    <Autocomplete
                                                        id="collectionTypeID"
                                                        options={collectionTypes}
                                                        getOptionLabel={(option) => option.collectionTypeName.toString()}
                                                        onChange={(e, value) => handleSearchDropdownChange(value)}
                                                        renderInput={(params) => <TextField {...params} label="Product *" variant="outlined" size="small" />}
                                                    />
                                                    {orderItemErrors["collectionTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["collectionTypeID"]}</FormHelperText>}
                                                </div>
                                                <div className="col-md">
                                                    <InputLabel shrink id="aspNetUserId">Purchasing Manager *</InputLabel>
                                                    <Select fullWidth
                                                        id="aspNetUserId"
                                                        name="aspNetUserId"
                                                        value={purchaseOrderItem.aspNetUserId}
                                                        onChange={(e) => handlePurchaseItemChange(e)}>
                                                        <MenuItem value="0">--Select Purchasing Manager--</MenuItem>
                                                        {generateDropDownMenu(users)}
                                                    </Select>
                                                    {errors["aspNetUserId"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["aspNetUserId"]}</FormHelperText>}
                                                </div>
                                                <div className="col-md pt-1">
                                                    <TextField fullWidth label="Price *"
                                                        name="price"
                                                        id="price"
                                                        value={purchaseOrderItem.price}
                                                        type="text"
                                                        onChange={(e) => handlePurchaseItemChange(e)}
                                                    />
                                                    {orderItemErrors["price"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["price"]}</FormHelperText>}
                                                </div>
                                                <div className="col-md">
                                                    <InputLabel shrink id="measuringUnit">Measuring Unit *</InputLabel>
                                                    <Select fullWidth
                                                        id="measuringUnit"
                                                        name="measuringUnit"
                                                        value={purchaseOrderItem.measuringUnit}
                                                        onChange={(e) => handlePurchaseItemChange(e)}>
                                                        <MenuItem value="0">--Select Measuring Unit--</MenuItem>
                                                        <MenuItem value="1">Kg</MenuItem>
                                                        <MenuItem value="2">Unit</MenuItem>
                                                    </Select>
                                                    {orderItemErrors["measuringUnit"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["measuringUnit"]}</FormHelperText>}
                                                </div>
                                            </div>
                                            {purchaseOrderItem.measuringUnit === "1" ?

                                                <div className="form-group row">
                                                    <div className="col-md pt-1">
                                                        <TextField fullWidth label="Package Weight *"
                                                            name="packageWeight"
                                                            id="packageWeight"
                                                            value={purchaseOrderItem.packageWeight}
                                                            type="text"
                                                            onChange={(e) => handlePurchaseItemChange(e)}
                                                        />
                                                        {orderItemErrors["packageWeight"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["packageWeight"]}</FormHelperText>}
                                                    </div>
                                                    <div className="col-md pt-1">
                                                        <TextField fullWidth label="Total Packages (Store) *"
                                                            name="totalPackagesStore"
                                                            id="totalPackagesStore"
                                                            value={purchaseOrderItem.totalPackagesStore}
                                                            type="text"
                                                            onChange={(e) => handlePurchaseItemChange(e)}
                                                        />
                                                        {orderItemErrors["totalPackagesStore"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesStore"]}</FormHelperText>}
                                                    </div>
                                                    <div className="col-md pt-1">
                                                        <TextField fullWidth label="Max Total Packages (Export) *"
                                                            name="totalPackagesExport"
                                                            id="totalPackagesExport"
                                                            value={purchaseOrderItem.totalPackagesExport}
                                                            type="text"
                                                            onChange={(e) => handlePurchaseItemChange(e)}
                                                        />
                                                        {orderItemErrors["totalPackagesExport"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesExport"]}</FormHelperText>}
                                                    </div>
                                                    <div className="col-md-3 pt-4">
                                                        <div className="d-inline">Exact Amount(Kg) : </div> <div className="d-inline" style={{ fontSize: '18px' }}>{purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesStore}</div>
                                                    </div>
                                                    <div className="col-md-3 pt-4">
                                                        <div className="d-inline">Max Amount(Kg) : </div><div className="d-inline" style={{ fontSize: '18px' }}>{purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesExport}</div>
                                                    </div>
                                                </div>
                                                :
                                                (purchaseOrderItem.measuringUnit === "2" ?
                                                    <div className="form-group row">
                                                        <div className="col-md pt-1">
                                                            <TextField fullWidth label="Package Weight *"
                                                                name="packageWeight"
                                                                id="packageWeight"
                                                                value={purchaseOrderItem.packageWeight}
                                                                type="text"
                                                                onChange={(e) => handlePurchaseItemChange(e)}
                                                            />
                                                            {orderItemErrors["packageWeight"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["packageWeight"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col-md pt-1">
                                                            <TextField fullWidth label="Total Packages (Store) *"
                                                                name="totalPackagesStore"
                                                                id="totalPackagesStore"
                                                                value={purchaseOrderItem.totalPackagesStore}
                                                                type="text"
                                                                onChange={(e) => handlePurchaseItemChange(e)}
                                                            />
                                                            {orderItemErrors["totalPackagesStore"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesStore"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col-md pt-1">
                                                            <TextField fullWidth label="Max Total Packages (Export) *"
                                                                name="totalPackagesExport"
                                                                id="totalPackagesExport"
                                                                value={purchaseOrderItem.totalPackagesExport}
                                                                type="text"
                                                                onChange={(e) => handlePurchaseItemChange(e)}
                                                            />
                                                            {orderItemErrors["totalPackagesExport"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["totalPackagesExport"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col-md-3 pt-4">
                                                            <div className="d-inline">Exact Amount(Kg) : </div> <div className="d-inline" style={{ fontSize: '18px' }}>{purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesStore}</div>
                                                        </div>
                                                        <div className="col-md-3 pt-4">
                                                            <div className="d-inline">Max Amount(Kg) : </div><div className="d-inline" style={{ fontSize: '18px' }}>{purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesExport}</div>
                                                        </div>
                                                    </div>
                                                    : null)
                                            }

                                            <Dialog open={openDialog} onClose={handleClose} fullWidth={true}
                                                aria-labelledby="form-dialog-title">
                                                <DialogTitle id="form-dialog-title">Update Unit Price</DialogTitle>
                                                <DialogContent>
                                                    <Box>
                                                        <div className="form-group row">
                                                            <div className="col-md-6 ">
                                                                <label> Order Number : {orderDetails.orderNumber} </label>
                                                            </div>
                                                            <div className="col-md-6 ">
                                                                <label> Item Name : {orderItemName} </label>
                                                            </div>
                                                            <div className="col-md-6 ">
                                                                <label> Supplier : {supplierName} </label>
                                                            </div>
                                                            <div className="col-md-6 ">
                                                                <label> Unit Price : {unitPrice} </label>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="form-group row"> 
                                                            <div className="col-md-6 ">
                                                                <TextField fullWidth label="New Unit Price "
                                                                    name="newunitprice"
                                                                    id="newunitprice"
                                                                    value={newunitprice.unitprice}
                                                                    type="text"
                                                                    onChange={(e) => handlUnitPriceChange(e)}

                                                                />
                                                            </div> 
                                                        </div> 
                                                    </Box>
                                                     
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleClose} color="primary">
                                                        Cancel
                                                    </Button>
                                                    <Button
                                                        onClick={() => trackPromise(UpdateUnitPrice())}
                                                        color="primary"
                                                        disabled={purchaseAdvice.statusTypeID == 5}
                                                    >
                                                        Update
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>

                                            <div className="form-group row">
                                                <div className="col">
                                                    <input
                                                        type="button"
                                                        className="btn btn-primary pull-right"
                                                        disabled={(purchaseOrderItem.measuringUnit === "0" ? true :
                                                            (validate(orderItemsschema, purchaseOrderItem))) || (purchaseAdvice.statusTypeID !== 1 && edit)}
                                                        onClick={handleAddItem}
                                                        value="Add"
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                {orderItemErrors["orderItem"] && <FormHelperText id="errbranchCode" className="text text-danger">{orderItemErrors["orderItem"]}</FormHelperText>}
                                            </div>
                                            {
                                                (items > 0) ?
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="table-responsive row-top-gap">
                                                                <table className="display dataTable no-footer">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Item Name</th>
                                                                            <th>Purchase Manager</th>
                                                                            <th>Price</th>
                                                                            <th>Package Weight</th>
                                                                            <th>Measuring Unit</th>
                                                                            <th>Total Packages (Store)</th>
                                                                            <th>Max Total Packages (Export)</th>
                                                                            <th>Exact Amount (Kg)</th>
                                                                            <th>Max Amount (Kg)</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <TableContentPurchaseView
                                                                            data={orderItemArray.filter(x => parseInt(x.state) !== 2)}
                                                                            contentRowNames={contentRowNames}
                                                                            handleClick={handleItemRemoveClick}
                                                                            purchaseValue={purchaseAdvice.statusTypeID}
                                                                        />
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                        : null
                                    }

                                    <div className="row pt-4">
                                        <div className="col">
                                            {itemDetails.length > 0 ?
                                                <TableContainer component={Paper}>
                                                    <Table aria-label="collapsible table">
                                                        <TableHead style={{ backgroundColor: "White" }}>
                                                            <TableRow>
                                                                <TableCell />
                                                                <TableCell style={tableHeaderStyle}>Item Name</TableCell>
                                                                <TableCell align="right" style={tableHeaderStyle}>Quantity</TableCell>
                                                                <TableCell align="right" style={tableHeaderStyle}>Measuring Unit</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {itemDetails.map((row, i) => (
                                                                <Row key={i} row={row} />
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer> : null
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="pt-3">
                                {orderDetails.statusTypeID !== 5 ? <div>
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value="Update"
                                        disabled={errors.dueDate}
                                    />
                                </div> : null}
                                <ReactToPrint
                                    trigger={() => <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Create PDF"
                                    />}
                                    content={() => componentRef.current}
                                    documentTitle={'View Orders'}
                                />
                                <div hidden={true}>
                                    <CreatePDF ref={componentRef} orderItemArray={orderItemArray}
                                        contentRowNames={contentRowNames}
                                        purchaseAdvice={purchaseAdvice} itemDetails={itemDetails}
                                        purchaseForPDF={purchaseForPDF}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}